import sharedCss from '../shared/shared.styles';

export default (theme: Object) => ({
  screenContainer: {
    ...sharedCss.screenContainer,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  screenTitle: {
    ...sharedCss.screenTitle(theme),
    textAlign: 'center',
    marginBottom: 24,
  },
  controlButtons: {
    ...sharedCss.controlButtons,
    justifyContent: 'stretch',
    marginTop: 28,
    '& > *': {
      flex: 1,
    },
    '& > *:not(:first-child)': {
      marginLeft: 12,
    },
  },
  controlButton: {
    ...sharedCss.controlButton,
    marginLeft: 0,
    width: '100%',
  },
  passwordInput: {
    width: '100%',
    marginBottom: '24px',
  },
  options: {
    display: 'flex',
  },
  stayLoggedIn: {
    lineHeight: '1.29',
    fontSize: theme.typography.fontSize,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.neutrals.secondaryText,
  },
  forgotPassword: {
    display: 'block',
    lineHeight: '1.29',
    fontSize: theme.typography.fontSize,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.neutrals.main,
    alignSelf: 'center',
  },
  snackbar: {
    background: theme.palette.secondary.main,
  },
  emailVerification: {
    lineHeight: '1.29',
    fontSize: theme.typography.fontSize,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.semantic.alert,
  },
});
